(function () {
  if (!window.Lenis) return;
  if (window.Shopify?.designMode) return;
  if (!window.matchMedia('(min-width: 1000px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const lenis = new Lenis({ lerp: 0.12, smoothWheel: true, allowNestedScroll: true });

  window.__lenis = lenis;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // Pause Lenis when the theme locks scroll (drawers, modals)
  // The theme adds/removes class "lock" on <html> via documentElement.classList
  new MutationObserver(function () {
    if (document.documentElement.classList.contains('lock')) {
      lenis.stop();
    } else {
      lenis.start();
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
})();
